import axios from "./axiosInstance";

const contactApi ={ 
 contact_detail: (data) => axios.post("contact-us", data),
    
}

export default contactApi;